import { LabeledColorSwatch } from "../../common-ui/components/color/display/LabeledColorSwatch";
import { Col } from "../../common-ui/components/grid/Col";
import { Row } from "../../common-ui/components/grid/Row";
import { ColorHelper } from "../../common-ui/helper/ColorHelper";
import { DesignTokens } from "../../common-ui/styles/design-tokens";

const { spacings } = DesignTokens;
const { rgbToARGB } = ColorHelper;

type ColorItem = {
  name: string;
  value: string;
  rgb: string;
};

type UniqueColorsProps = {
  colors: ColorItem[];
};

export const UniqueColors: React.FC<UniqueColorsProps> = ({ colors }) => (
  <Row gutter={[spacings.middle, spacings.xsmall]}>
    {colors.map((color, index) => (
      <Col key={index}>
        <LabeledColorSwatch
          label={`${color.value} ${color.name}`} // e.g., "1797 Calypso Blue"
          labelSize="xlarge"
          argb={rgbToARGB(color.rgb)}
          size={24}
        />
      </Col>
    ))}


  </Row>
);
